import Vue from 'vue'
import footer from './footer'

// export default {
  Vue.component('footer', footer)
// }